import {FormField} from "../FormField";
import {BalanceTable} from "./BalanceTable";
import {formatMoney} from "../functions/formatMoney"

require('../../../sass/components/CustomerBox/_balance.scss');

export const Balance = {
    name: 'Balance',
    components: {
        FormField,
        BalanceTable
    },
    data: function () {
        return {
            amount_add: '',
            changed: false
        }
    },
    props: {
        url: {
            type: String,
            default: '/'
        },
        balance: {
            type: Number,
            default: 0.00
        },
        balance_free_tax: {
            type: Number,
            default: 0.00
        },
        free_tax: {
            type: Boolean,
            default: false
        },
        only_free_tax: {
            type: Boolean,
            default: false
        }
    },
    mounted: function() {
        if(!!this.only_free_tax)
            this.free_tax = true;
    },
    watch: {
      amount_add: function(val) {
          this.amount_add = formatMoney(val);
      }
    },
    computed: {
        amount() {
            return this.free_tax ? this.balance_free_tax : this.balance;
        },
        hidden_for_free_tax() {
            if(this.only_free_tax && !this.free_tax)
                return true;
            return false;
        }
    },
    methods: {
        setBalanceCharge() {
            let amount = parseFloat(this.amount_add) * 100;
            let amount_net = Math.round(amount / 1.23);
            let amount_gross_again = Math.round(amount_net * 1.23);
            this.amount_add = amount_gross_again / 100;
            this.changed = amount !== amount_gross_again;
        },
        tabClick(free_tax) {
            this.free_tax = free_tax;
            if (this.hidden_for_free_tax)
                this.amount_add = ''
        }
    },
    template: `
      <div>
        <div class="balance--value">
          {{ amount }}&nbsp;zł
        </div>
        <div class="balance--tabs">
          <div class="balance--tab" :class="{'active': !free_tax}" @click="tabClick(false)">Saldo główne</div>
          <div class="balance--tab" :class="{'active': free_tax}" @click="tabClick(true)">Saldo poza EU</div>          
        </div>
          <div style="overflow-x: hidden; overflow-y: auto;">
            <div class="balance--add" v-bind:class="{'show--left': hidden_for_free_tax}">
                <div class="balance--charge">
                  <form :action="url" id="balance-charge" method="post" v-if="!hidden_for_free_tax">
                    <input v-if="free_tax" type="hidden" name="free_tax" value="1">
                        <div is="FormField"
                             step="0.01"
                             name="amount"
                             suffix="PLN"
                             suffixWidth="50"
                             v-model="amount_add"
                             placeholder="Wpisz kwotę doładowania"
                             @change="setBalanceCharge()"
                             :disabled="hidden_for_free_tax"
                        >
                        </div>
                    <span class="form__field__error" v-if="changed" style="color: green;">
                      Ze względów księgowych kwota doładowania została zmieniona.
                    </span>
                    <span class="form__field__error" v-if="amount_add > 100000">
                      Kwota doładowania nie może być większa niż 100 000 PLN
                    </span>
                    <button type="submit" 
                            class="button button--primary button--full"
                            :disabled="amount_add === '' || parseFloat(amount_add) === 0 || parseFloat(amount_add) > 100000 || hidden_for_free_tax">
                      Doładuj saldo
                    </button>
                  </form>
                </div>
                <div class="balance--desc" v-if="free_tax">
                  Saldo poza EU służy do nadawania przesyłek do państw nienależących do Unii Europejskiej.
                  <br>
                  Przesyłki te rozliczane są ze stawką VAT 0%.
                </div>
                <div class="balance--desc" v-else>
                  Saldo główne służy do nadawania przesyłek do państw należących do Unii Europejskiej.
                  <br>
                  Przesyłki te rozliczane są ze stawką VAT 23%.
                </div>
            </div>
            <BalanceTable :free_tax="free_tax" class="balance--table"></BalanceTable>
          </div>
      </div>
    `
};